import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthLoginService } from 'src/app/page/auth-page/service/auth-login.service';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable({
	providedIn: 'root',
})
export class RequestSatisfactionService {
	getSatisfactionPinUrl = environment.baseApiUrl + 'request/{requestID}/satisfaction';
	postEvaluateRequestUrl = environment.baseApiUrl + 'request/{requestID}/satisfaction/{hashID}';

	updateEvaluateRequestUrl = environment.baseApiUrl + 'openRequestByMail/requestEvaluation/{requestID}?satisfaction_level={level}';

	constructor(
		private http: HttpClient,
		private AuthLoginService: AuthLoginService
	) {}

	evaluateRequest(
		requestId: string,
		satisfactionPin: string,
		isThisRequestFinished: boolean,
		satisfactionLevel: string,
		commentary: string
	): Observable<JSON[]> {
		const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken() });
		const postEvaluateRequestUrl = this.postEvaluateRequestUrl.replace('{requestID}', requestId).replace('{hashID}', satisfactionPin);
		const body = {
			satisfaction_pin: satisfactionPin,
			aceite: isThisRequestFinished ? 1 : 0,
			satisfaction_level: satisfactionLevel,
			satisfaction_comments: commentary,
		};
		return this.http.post<JSON[]>(postEvaluateRequestUrl, body, { headers: headers });
	}

	getSatisfactionPin(requestId: string): Observable<JSON[]> {
		const headers = new HttpHeaders({ Authorization: 'Bearer ' + this.AuthLoginService.getSessionToken() });
		const getSatisfactionPinUrl = this.getSatisfactionPinUrl.replace('{requestID}', requestId);
		return this.http.get<JSON[]>(getSatisfactionPinUrl, { headers: headers });
	}

	updateEvaluateRequest(requestId: string, level: string): Observable<JSON[]> {
		const updateEvaluateRequestUrl = this.updateEvaluateRequestUrl.replace('{requestID}', requestId).replace('{level}', level);
		return this.http.put<JSON[]>(updateEvaluateRequestUrl, {});
	}
}
